export const query_users_byTenantId = `
query getUsersByTenantId($tenantId: String!) {
  user_tenant(where: {TenantId: {_eq: $tenantId}}, order_by: {user: {Username: asc}}) {
    UserId
    TenantId
    Type
    TenantTipoId
    base_tipo_tenant {
      Value
    }
    user {
      Username
      Email
      Name
      Surname
      Locale
      IsRespAntiRic
      IsActive
      IsDeleted
      IsBanned
      CreatedOn
      Cf
      LastVersion
      IsEnabledToCreateLawyers
      user_roles(where : {TenantId : {_eq:$tenantId}}){
        Role
        DateStart
        DateEnd
      }
    }
  }
}`;
export const query_users_byCompanyId = `
query getUsersByCompanyId($tenantId: String!, $aziendaId: Int!) {
  user_tenant(where:
    {TenantId: {_eq: $tenantId},
    user: { user_permissions: {AziendaId: {_eq: $aziendaId}_or: [{CanRead: {_eq: true}}, {CanCreate: {_eq: true}}, {CanUpdate: {_eq: true}}, {CanDelete: {_eq: true}}]}}
  }, order_by: {user: {Username: asc}}) {
    UserId
    TenantId
    Type
    TenantTipoId
    base_tipo_tenant {
      Value
    }
    user {
      Username
      Email
      Name
      Surname
      Locale
      IsRespAntiRic
      IsActive
      IsDeleted
      IsBanned
      CreatedOn
      Cf
    }
  }
}`;
export const query_user_byId = `
query getUserById($userId: String!) {
  user(where: {UserId: {_eq: $userId}}) {
    UserId
    Username
    Email
    Name
    Surname
    Locale
    IsRespAntiRic
    IsActive
    IsDeleted
    IsBanned
    CreatedOn
    Cf
    LastVersion
    IsEnabledToCreateLawyers
    user_tenants {
      Id
      UserId
      TenantId
      Type
      TenantTipoId
      base_tipo_tenant {
        Value
      }
    }
  }
}`;
export const query_users_respAntiric = `
query getUsersRespAntiRic($tenantId: String!) {
  user_tenant(where:
    {
      TenantId: {_eq: $tenantId}
    }) {
    UserId
    TenantId
    Type
    TenantTipoId
    base_tipo_tenant {
      Value
    }
    user {
      Username
      Email
      Name
      Surname
      Locale
      IsRespAntiRic
      IsActive
      IsDeleted
      IsBanned
      CreatedOn
      Cf
      user_roles(where : {TenantId : {_eq:$tenantId}}){
        Role
        DateStart
        DateEnd
      }
    }
  }
}`;
export const query_fascicolo_user_count_byUserId = `
query countFascicoloUserByUserId($tenantId: String!, $aziendaId: Int!, $userId: String!) {
  fascicolo_aggregate(where: {
    TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
    _or: [
      {_or: [
        {prestaziones: {prestazione_users: {UserId: {_eq: $userId}}}}
      ]}
  ]}) {
    aggregate {
      count
    }
  }
}`;
export const query_users_owner = `
  query getUsersOwner($tenantId: String!) {
    user_tenant(where:
      {
        TenantId: {_eq: $tenantId},
        Type : {_eq: "OWNER"},
        user: { IsActive: {_eq: true}, IsDeleted: {_eq: false}, IsBanned: {_eq: false} }
      }) {
      UserId
      TenantId
      Type
      TenantTipoId
      user {
        Username
        Email
      }
    }
  }`;